(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2409],{

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 9535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Shared_BrandHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/analytics.js


const addDataLayerOnClick = function() {
    let datalayerPageName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", item = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const eventInfo = {
        clickInternalLinks: "".concat(item.linkToNewTab || constants.BRAND_NAME.annSacks || constants.BRAND_NAME.sterling || constants.BRAND_NAME.homeEnergy ? "false" : "true"),
        internalLinkPosition: "global header",
        internalLinkZoneName: "".concat(datalayerPageName).concat(datalayerPageName ? ":" : "", "global header"),
        internalLinkURL: "".concat((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")),
        internalLinkName: "brand sync:".concat(item.brandName.toLowerCase()),
        eventName: "brand sync",
        internalLinkType: "global header:navigation",
        eventType: "click",
        eventAction: "brand sync"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/index.jsx



const BrandSwitcher = (props)=>{
    const { data , datalayerPageName  } = props;
    const handleOnClick = (e, item)=>{
        var ref;
        addDataLayerOnClick(datalayerPageName, item);
        window.open((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""), "".concat((0,helper.convertStringToBoolean)(item.linkToNewTab) ? "_blank" : "_self"), item.linkRef ? "noreferrer" : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brand-switcher ".concat(datalayerPageName === "checkout" ? "checkout-brand" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-nav-panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "gbh-nav navbar navbar-xpand-sm navbar-dark justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "gbh-nav__list navbar-nav",
                    children: data.items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "gbh-nav__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer gbh-nav--link ".concat(item.highlight && item.highlight === "true" ? "gbh-nav__link--active" : ""),
                                "aria-label": "".concat(item.brandName, ". Go to ").concat(item.brandName, "'s Home Page"),
                                onClick: (e)=>handleOnClick(e, item),
                                role: "link",
                                children: item.brandName
                            })
                        }, "brand-".concat(index)))
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandSwitcher = (BrandSwitcher);

// EXTERNAL MODULE: ./components/Shared/UtilityNavHeader.jsx + 14 modules
var UtilityNavHeader = __webpack_require__(95518);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./components/Shared/index.module.scss
var index_module = __webpack_require__(3738);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Shared/BrandHeaderFiller.jsx
/* provided dependency */ var process = __webpack_require__(83454);



// import cartEmptyIcon from "/icons/cart-icon-empty.svg"
const BrandHeaderFiller = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-nav__findStore--link cmp-find-place",
                                    children: process.env.NEXT_PUBLIC_FIND_STORE_LABEL || "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "United States" || 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-labelledby": "country-ada",
                                    "aria-expanded": "false",
                                    className: "gbh-nav__region--link active-country ",
                                    children: [
                                        "United States" || 0,
                                        " -",
                                        " ",
                                        "EN" || 0
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "UtilityWidgets_utilityWidgetsWrapper__Wz0ZS",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "auth-widget auth-widget__menu AuthUtilityNav_authUtilityNavWrapper__iJgYU",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "auth-nav",
                                                    "aria-expanded": "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            tabIndex: 0,
                                                            role: "button",
                                                            name: "avatarIcon",
                                                            "aria-label": "Sign In Collapsed",
                                                            src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTkgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+U2lnbiBJbiBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTmF2aWdhdGlvbi9EZXNrdG9wL1V0aWxpdHktQmFyL0xvZ2dlZC1PdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzkxLjAwMDAwMCwgLTEzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVXRpbGl0eS1MaW5rcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOC4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iU2lnbi1Jbi1JY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzEuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNiwxNy41IEMxOC40MTQyNzMzLDE3LjUgMjAuMzg0NDg5MSwxOS40MDEyMzY1IDIwLjQ5NTEwMiwyMS43ODgxNjQzIEwyMC41LDIyIEwyMC41LDI1IEwxOS41LDI1IEwxOS41LDIyIEMxOS41LDIwLjEzMTQzNjYgMTguMDM1NzIyNCwxOC42MDQ4NzM2IDE2LjE5MjAzNTIsMTguNTA1MTc4OSBMMTYsMTguNSBMNywxOC41IEM1LjEzMTQzNjYsMTguNSAzLjYwNDg3MzU1LDE5Ljk2NDI3NzYgMy41MDUxNzg4NiwyMS44MDc5NjQ4IEwzLjUsMjIgTDMuNSwyNSBMMi41LDI1IEwyLjUsMjIgQzIuNSwxOS41ODU3MjY3IDQuNDAxMjM2NTIsMTcuNjE1NTEwOSA2Ljc4ODE2NDMsMTcuNTA0ODk4IEw3LDE3LjUgTDE2LDE3LjUgWiBNMTEuNSw1LjUgQzE0LjI2MTQyMzcsNS41IDE2LjUsNy43Mzg1NzYyNSAxNi41LDEwLjUgQzE2LjUsMTMuMjYxNDIzNyAxNC4yNjE0MjM3LDE1LjUgMTEuNSwxNS41IEM4LjczODU3NjI1LDE1LjUgNi41LDEzLjI2MTQyMzcgNi41LDEwLjUgQzYuNSw3LjczODU3NjI1IDguNzM4NTc2MjUsNS41IDExLjUsNS41IFogTTExLjUsNi41IEM5LjI5MDg2MSw2LjUgNy41LDguMjkwODYxIDcuNSwxMC41IEM3LjUsMTIuNzA5MTM5IDkuMjkwODYxLDE0LjUgMTEuNSwxNC41IEMxMy43MDkxMzksMTQuNSAxNS41LDEyLjcwOTEzOSAxNS41LDEwLjUgQzE1LjUsOC4yOTA4NjEgMTMuNzA5MTM5LDYuNSAxMS41LDYuNSBaIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPiA=",
                                                            alt: "Sign In"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "auth-nav__menu ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "wishlist-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "aria-label": "View your wishlist",
                                                    className: "gbh-data-layer",
                                                    href: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "View your wishlist",
                                                        "aria-hidden": "true",
                                                        role: "presentation",
                                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                    })
                                                })
                                            }),
                                            process.env.NEXT_PUBLIC_DISABLE_CART_ICON === "true" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "cart-indicator-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-indicator false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "aria-label": "View your cart containing 0 item",
                                                        role: "link",
                                                        className: "gbh-data-layer",
                                                        href: "/en/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/cart-icon-empty.svg",
                                                            alt: "Cart"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeaderFiller = (BrandHeaderFiller);

// EXTERNAL MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx + 4 modules
var MiniCart = __webpack_require__(67101);
;// CONCATENATED MODULE: ./components/Shared/CheckoutUtilityNavheader.jsx


const CheckoutUtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "listitem",
            className: "cart-indicator-widget__checkout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                checkoutPage: data === null || data === void 0 ? void 0 : data.linkCart,
                eventHandler: eventHandler,
                source: "from desk"
            })
        })
    });
};
/* harmony default export */ var CheckoutUtilityNavheader = (CheckoutUtilityNavHeader);

;// CONCATENATED MODULE: ./components/Shared/BrandHeader.jsx









const BrandHeader = (props)=>{
    const { data , eventHandler  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const isSsr = (0,useIsSsr/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                if (key === "brand_switcher" || key === "brand_switcher_copy") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandSwitcher, {
                        data: item,
                        datalayerPageName: datalayerPageName
                    }, key);
                }
                if (key === "utilitynavheader" || key === "utilitynavheader_v2") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeaderFiller, {}) : key === "utilitynavheader_v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutUtilityNavheader, {
                            data: item,
                            eventHandler: eventHandler
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityNavHeader/* default */.Z, {
                            data: item,
                            eventHandler: eventHandler
                        })
                    }, key);
                }
                return null;
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeader = (BrandHeader);


/***/ })

}]);